module.exports = __webpack_public_path__ + "static/media/moyo.8fd5f609.png";